export const config = {
  propsName: 'renderProps',
  name: 'SpTextarea',
  type: 'formTmpsConfig',
  icon: 'el-icon-edit-outline',
  cnName: '多行输入',
  base: {
    title: '多行输入',
    subtitle: 'SpTextarea_subtitle',
    padded: true,
    flex: '1',
    margin: [0, 0, 0, 0]
  },
  props: [
    // {
    //   type: () => import('@/weappTmps/comps/flex/index.vue'),
    //   cmpPath: '/comps/flex/index.vue',
    //   key: 'flex',
    //   bind: {
    //     label: '排列方式'
    //   },
    //   on: {},
    //   value: null
    // },
    {
      type: () => import('@/weappTmps/comps/margin/index.vue'),
      cmpPath: '/comps/margin/index.vue',
      key: 'margin',
      bind: {
        label: '边距'
      },
      on: {},
      value: null
    },
    {
      type: 'el-input',
      key: 'title',
      bind: {
        label: '标题名称',
        placeholder: '请输入标题名称'
      },
      value: ''
    },
    {
      type: 'el-input',
      key: 'placeholder',
      bind: {
        label: '提示内容',
        placeholder: '请输入提示内容'
      },
      value: ''
    },
    {
      type: 'el-input',
      key: 'defaultVal',
      bind: {
        label: '默认内容',
        placeholder: '请输入默认值',
        type: 'textarea'
      },
      value: ''
    },
    {
      type: 'el-switch',
      key: 'required',
      bind: {
        label: '是否必填'
      },
      value: false
    }
    // {
    //   type: () => import('./comps/test.vue'),
    //   cmpPath: '/formTmps/SpTextarea/comps/test.vue',
    //   key: 'test',
    //   bind: {
    //     label: 'import'
    //   },
    //   value: null
    // },
    // {
    //   render: (h) => {
    //     return (
    //       <div class='avatar-wrap'>
    //         <div class='avatar-icon'>test render</div>
    //         <div class='avatar-info'>
    //           <div class='name'>item_name </div>
    //         </div>
    //       </div>
    //     )
    //   },
    //   key: 'test2',
    //   bind: {
    //     label: 'render'
    //   },
    //   value: null
    // }
    // {
    //   // type: () => import('./comps/xxxx'),
    //   key: '',
    //   value: []
    // },
    // {
    //   type: 'btns',

    // }
  ]
}
